<template>
  <label
    class="app-radio"
    :class="{ disabled, checked, 'full-width': fullWidth }"
    @click.stop.prevent="toggleCheck"
  >
    <input v-bind="$attrs" type="radio" :checked="checked" />

    <i class="radio-circle"></i>

    <div v-if="$slots.default" class="app-radio-content">
      <slot />
    </div>
  </label>
</template>

<script>
import { equal } from '@/helpers'

export default {
  name: 'AppRadio',
  inheritAttrs: false,

  props: {
    model: [String, Number, Boolean, Object, Array],

    value: {
      type: [String, Number, Boolean, Object, Array],
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    fullWidth: {
      type: Boolean,
      default: true,
    },
  },

  model: {
    prop: 'model',
    event: 'change',
  },

  computed: {
    checked() {
      const checked = this.$attrs.checked

      if (checked !== undefined) return checked

      return equal(this.model, this.value)
    },
  },

  methods: {
    toggleCheck() {
      this.$emit('change', this.value)
    },
  },
}
</script>

<style lang="scss" scoped>
@use 'sass:math';

@import '@/styles/settings.scss';

.app-radio {
  $radioSize: 20px;
  $transitionDuration: 200ms;
  display: inline-flex;
  gap: 0.5rem;
  line-height: 120%;
  padding-top: math.div($defaultPadding, 4);
  padding-bottom: math.div($defaultPadding, 4);

  &.full-width {
    display: flex;
  }

  > input {
    display: none;
  }

  &.checked {
    .radio-circle {
      border-color: $primaryColor;

      &::after {
        opacity: 1;
        width: calc(100% - 4px);
        height: calc(100% - 4px);
      }
    }
  }

  .radio-circle {
    min-width: $radioSize;
    max-width: $radioSize;
    min-height: $radioSize;
    max-height: $radioSize;
    display: block;
    border-radius: 50%;
    background-color: #fff;
    padding: 2px;
    border: 2px solid rgba(0, 0, 0, 0.54);
    display: block;
    transition: border-color $transitionDuration;
    overflow: hidden;
    position: relative;

    &::after {
      position: absolute;
      top: 2px;
      left: 2px;
      right: 0;
      bottom: 0;
      opacity: 0;
      border-radius: 50%;
      content: '';
      width: 0;
      height: 0;
      background-color: $primaryColor;
    }
  }

  .app-radio-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
</style>
